import { serviceName } from '../resources/serviceConstants';
import {
  FILE_UPLOAD_SUMMARY_ENDPOINT,
  FILE_UPLOAD_SUBMIT_ENDPOINT,
  FILE_UPLOAD_UPLOAD_DATE_ENDPOINT,
  FILE_UPLOAD_SAMPLE_FILE_ENDPOINT,
} from '../resources/endPoint';

export const fetchFileUploadSummary = () => ({
  url: FILE_UPLOAD_SUMMARY_ENDPOINT,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});

export const submitProjectFileUpload = (payload) => ({
  url: FILE_UPLOAD_SUBMIT_ENDPOINT,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
  timeout: 300000,
});

export const updateLastEffortUploadedDate = (payload) => ({
  url: FILE_UPLOAD_UPLOAD_DATE_ENDPOINT,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});

export const getProjectFileUploadSampleFile = (type) => ({
  url: `${FILE_UPLOAD_SAMPLE_FILE_ENDPOINT}?type=${encodeURIComponent(type)}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});
